import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { ApiService } from '../../core/services/index';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class packagesService {

    private packagesSubject = new BehaviorSubject<any>([]);
    public packages$: Observable<any> = this.packagesSubject.asObservable();

    constructor(private _api: ApiService) { 
        this.fetchPackages();
    }

    fetchPackages(){
        this.getAllPackages().subscribe(res => {

            this.packagesSubject.next(res.data);
        })
    }

    getAllPackages(){
        return this._api.get(`${"packages"}`)
            .pipe(
                map((res:any) => res),
                catchError((error: any) => throwError(() => error))
            )
    }

}

